/**
 * Per-device identity for the fan page. A fan on a screen tag has no seat, so
 * the device is what makes a vote, a prediction or (Release B) an order
 * theirs. Seat fans send it too — harmless, and it tells two phones on one
 * seat apart in Insights. Lives in localStorage so it survives reloads and
 * is shared by every tab of this origin; never sent anywhere but our own
 * database.
 */
export const DEVICE_ID_KEY = 'idseat_device_id';

const UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

let memoryId: string | null = null;

function mint(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  // Older WebViews: RFC 4122 v4 from getRandomValues.
  const b = new Uint8Array(16);
  crypto.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

export function getDeviceId(): string {
  try {
    const stored = localStorage.getItem(DEVICE_ID_KEY);
    if (stored && UUID_V4.test(stored)) return stored;
    const fresh = memoryId && UUID_V4.test(memoryId) ? memoryId : mint();
    localStorage.setItem(DEVICE_ID_KEY, fresh);
    memoryId = fresh;
    return fresh;
  } catch {
    // Storage blocked (private mode quota, disabled cookies): stable for this page load at least.
    if (!memoryId) memoryId = mint();
    return memoryId;
  }
}
